<template>
  <div id="schedule-report-item-form">
    <div class="schedule-report-item-form-files">
      <!-- file previews -->
      <div v-for="(file, i) in filePreviewData" :key="i" class="pb-2">
        <div class="file-preview">
          <img v-if="file.type.includes('image')" :src="file.url" :alt="file.name" />
          <video v-else-if="file.type.includes('video')" controls :src="file.url"></video>
          <a v-else :href="file.url" target="_blank">
            <i class="fas fa-file text-success"></i>
          </a>
        <base-button
          btn-icon-only
          icon
          size="sm"
          type="link"
          class="remove-file-btn text-danger"
          @click="removeFile(i)"
        >
          <i class="fas fa-times"></i>
        </base-button>
        </div>
        <!-- <span class="file-name" @click="fileInput.click()">{{ file.name }}</span><br> -->
        <span class="file-size">{{ typeof file.size == 'number' ? ((file.size || 0) / (1024*1024)).toLocaleString() + ' MB' : file.size }}</span>
      </div>
      <input type="file" ref="fileInput" @input="onFileInput" multiple hidden>
    </div>
    <div class="schedule-report-item-form-inputs">
      <base-button
        btn-icon-only
        icon
        type="link"
        @click="$refs.fileInput.click()"
      >
        <i class="fab fa fa-plus"></i>
      </base-button>

      <base-input
        valid
        wrapper-class="py-0 px-2"
        placeholder=""
        v-model="scheduleReportItem.content"
        @keyup.enter.prevent="saveScheduleReportItem"
      >
        <template v-slot:success><span></span></template>
      </base-input>

      <base-button
        v-if="isEdition"
        :valid="true"
        btn-icon-only
        icon
        type="transparent"
        @click="emit('cancel-edit')"
      >
        Cancelar edição
      </base-button>
      <base-button
        v-if="isEdition"
        v-loading="loading"
        :valid="true"
        btn-icon-only
        icon
        type="success"
        @click="saveScheduleReportItem"
      >
        Salvar edição
      </base-button>
      <base-button
        v-else
        v-loading="loading"
        :valid="true"
        btn-icon-only
        icon
        type="success"
        @click="saveScheduleReportItem"
      >
        <i class="fab fa fa-paper-plane"></i>
      </base-button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from "vue";

const emit = defineEmits(["input", "save", "edit", "create", "cancel-edit"]);

const props = defineProps({
  value: {
    type: Object,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const scheduleReportItem = computed({
  get: () => props.value,
  set: (value) => emit("input", value),
});

const fileInput = ref(null);

const filePreviewData = computed(() => {
  if (!scheduleReportItem.value.media) return [];

  return scheduleReportItem.value.media.map((file) => ({
    name: file.name,
    type: file.type || file.content_type,
    size: file.size || file.file_size,
    url: file instanceof File ? URL.createObjectURL(file) : file.path,
  }));
});

const onFileInput = (event) => {
  const files = event.target.files;

  if (!files.length) return;
  if (!scheduleReportItem.value.media) scheduleReportItem.value.media = [];

  scheduleReportItem.value.media = [...scheduleReportItem.value.media, ...files];
  scheduleReportItem.value = { ...scheduleReportItem.value };

  console.debug("[ScheduleReportItemForm][onFileInput]", scheduleReportItem.value.media);
};

const removeFile = (index) => {
  scheduleReportItem.value.media.splice(index, 1);
};

const saveScheduleReportItem = () => {
  emit("save", scheduleReportItem.value);

  if (isEdition.value) {
    emit("edit", scheduleReportItem.value);
  } else {
    emit("create", scheduleReportItem.value);
  }
};

const isEdition = computed(() => {
  return !!scheduleReportItem.value.id;
});
</script>

<style lang="scss">
#schedule-report-item-form {
  .schedule-report-item-form-inputs {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    &>* {
      flex-grow: 0;
    }

    &>span {
      flex-grow: 1;
    }

    .btn {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;

      i.fab {
        font-size: 1.4rem;
      }
    }

  }

  .schedule-report-item-form-files {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    min-width: 100%;
    margin-right: 10px;
    overflow-x: auto;

    .file-name {
      font-size: 0.8rem;
      font-weight: bold;
      cursor: pointer;
    }

    .file-size {
      font-size: 0.8rem;
      color: #999;
    }

    .file-preview {
      width: 60px;
      height: 60px;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;

      .remove-file-btn {
        position: absolute;
        border-radius: 10px;
        top: -5px;
        right: -9px;
        z-index: 1;

        i {
          font-size: 1rem;
        }

        &:hover {
          background-color: rgba(255, 255, 255, 0.85);
        }
      }

      img, video {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      a {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 2rem;
        color: #000;
      }
    }
  }
}
</style>
